import axios from 'axios';
import { tansParams, blobValidate } from '@/utils/index';
import { saveAs } from 'file-saver';

axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'application/json, text/plain, */*'
  }
})

service.interceptors.request.use(
  config => {
    config.data = JSON.stringify(config.data)
    return config
  },
  error => {
    Promise.reject(error)
  }
)

service.interceptors.response.use(res => {
    const code = res.status || 200;
    const message = res.data.message || '未知异常';
    if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
      return res.data
    }
    if (code !== 200) {
      window.alert(message)
      return Promise.reject(res.data)
    } else {
      const { status } = res.data;
      if(status === 'ERROR') {
        window.alert(message)
        return Promise.reject(res.data)
      } else if(status === 'INFO') {
        return res.data
      } else if(status === 'WARNING') {
        return res.data
      } else {
        return res.data
      }
    }
  },
  error => {
    // const code = error.response.status;
    return Promise.reject(error)
  }
)

export function downloadFile(url, params, filename, config) {
  return service.post(url, params, {
    transformRequest: [(params) => { return tansParams(params) }],
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    responseType: 'blob',
    ...config
  }).then(async (data) => {
    const isLogin = await blobValidate(data);
    if (isLogin) {
      const blob = new Blob([data])
      saveAs(blob, filename)
    } else {
      const resText = await data.text();
      const rspObj = JSON.parse(resText);
    }
  }).catch((r) => {
    console.error(r)
    // notification.error({
    //   message: '下载文件出现错误，请联系管理员！',
    //   offset: 50,
    // })
  })
}

export default service

